import {onDomReady} from "../../shared/ts/helpers/on-dom-ready";

const collapsibleRootClassName = 'collapsible'

const collapsibleChevronClassName = 'collapsible__chevron'
const collapsibleChevronOpenClassName = `${collapsibleChevronClassName}--open`

const collapsibleLabelClassName = 'collapsible__label'
const collapsibleLabelOpenClassName = `${collapsibleLabelClassName}--open`

// Showing and hiding the panel itself is done by <details>, so this only
// syncs the chevron and label styling. That way the accordion still opens
// and closes without JavaScript.

/**
 * @param {HTMLDetailsElement} rootElement
 */
function showCollapsible(rootElement) {
  rootElement.querySelector('.' + collapsibleChevronClassName).classList.add(collapsibleChevronOpenClassName)
  rootElement.querySelector('.' + collapsibleLabelClassName).classList.add(collapsibleLabelOpenClassName)
  rootElement.open = true
}

/**
 * @param {HTMLDetailsElement} rootElement
 */
function hideCollapsible(rootElement) {
  rootElement.querySelector('.' + collapsibleChevronClassName).classList.remove(collapsibleChevronOpenClassName)
  rootElement.querySelector('.' + collapsibleLabelClassName).classList.remove(collapsibleLabelOpenClassName)
  rootElement.open = false
}

function init() {

  for (let linkElement of document.querySelectorAll('a')) {
    const href = linkElement.href
    if (typeof href !== 'string' || href.length === 0) {
      continue
    }

    const hash = linkElement.hash
    if (hash.length <= 1 || hash[1] !== 'c') {
      continue
    }

    // The link only changes the fragment of the url.
    // But if the current location hash is the same as the one of the target,
    // the browser will jump to the element,
    // but it won't dispatch a HashChangeEvent.
    // So we dispatch a HashChangeEvent
    linkElement.addEventListener('click', () => {
      if (linkElement.href === window.location.href) {
        const hashChangeEvent = new HashChangeEvent('hashchange', {
          newURL: window.location.href,
          oldURL: window.location.href
        })
        window.dispatchEvent(hashChangeEvent)
      }
    })
  }

  for (let collapsibleElement of document.getElementsByClassName(collapsibleRootClassName)) {
    if (!(collapsibleElement instanceof HTMLDetailsElement)) {
      continue
    }

    collapsibleElement.addEventListener('toggle', () => {
      if (collapsibleElement.open) {
        showCollapsible(collapsibleElement)
      } else {
        hideCollapsible(collapsibleElement)
      }
    })
  }

  /**
   * @param {string} hashContent
   */
  function openFromHashContent(hashContent) {
    if (hashContent.length === 0) {
      return;
    }
    const element = document.getElementById(hashContent)
    if (element === null) {
      return;
    }
    if (!element.classList.contains(collapsibleRootClassName)) {
      return;
    }
    showCollapsible(element)
  }

  /**
   * @param {HashChangeEvent} event
   */
  function onHashChange(event) {
    const url = new URL(event.newURL)

    if (url.hash.length <= 1) {
      return
    }

    openFromHashContent(url.hash.substring(1))
  }

  // register hash change listener for auto open of collapsible
  window.addEventListener('hashchange', onHashChange)

  openFromHashContent(window.location.hash.substring(1) || '')
}

onDomReady(init)
